import moment from 'moment';
import lang from '../lang/translator';

let options = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

let filter = {
  toLocaleDate: function (date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY')
    // return new Date(date.replace(/-/g, '/')).toLocaleDateString('ru')
  },
  toLocaleDateTime: function (date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm')
  },
  toFirstLetter: function (text) {
    return text.charAt(0)
  },
  phaseNameByTypeId: function (phaseTypeId) {
      let name = '';
      switch (parseInt(phaseTypeId)) {
        case 0:
          name = lang.get('protocol.all_phases');
          break;
        case 1:
            name = lang.get('protocol.mastering');
            break;
        case 2:
            name = lang.get('protocol.rotation');
            break;
        case 3:
            name = lang.get('protocol.support');
            break;
        case 4:
          name = lang.get('protocol.fluency');
          break;
        case 5:
          name = lang.get('protocol.mastering');
          break;
      }
      return name;
  },

  intervalNameByTypeId: function (phaseTypeId) {
    let name = '';
    switch (parseInt(phaseTypeId)) {
      case 1:
        name = lang.get('protocol.through_each_lesson');
        break;
      case 2:
        name = lang.get('protocol.after_one_lesson');
        break;
      case 3:
        name = lang.get('protocol.after_two_classes');
        break;
      case 4:
        name = lang.get('protocol.after_three_classes');
        break;
      case 5:
        name = lang.get('protocol.once_a_week');
        break;
      case 6:
        name = lang.get('protocol.once_every_two_weeks');
        break;
      case 7:
        name = lang.get('protocol.once_a_month');
        break;
      default:
        name = lang.get('protocol.all_intervals');
        break;

    }
    return name;
  },
};

export default filter



// WEBPACK FOOTER //
// ./src/filters/filters.js